<template>
  <div>
    <v-dialog
      v-model="model"
      persistent
      max-width="650px"
      class="finish-order-wrapper"
    >
      <v-card class="finish-order-wrapper">
        <v-card-title>
          <span class="text-h5">Finish order</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
            >
              <p>
                Are you sure you want to finish the order?
              </p>
            </v-col>
            <v-col cols="12">
              <div class="param-list">
                <div class="param-list__item param-item">
                  <div class="param-item__name">
                    Time
                  </div>
                  <div class="param-item__value">
                    {{ timer }}
                  </div>
                </div>

                <div class="param-list__item param-item">
                  <div class="param-item__name">
                    Mode
                  </div>
                  <div class="param-item__value">
                    {{ order.team_count }}
                  </div>
                </div>

                <div class="param-list__item param-item">
                  <div class="param-item__name">
                    Client
                  </div>
                  <div class="param-item__value">
                    {{ order.player_name }}
                  </div>
                </div>

                <div class="param-list__item param-item">
                  <div class="param-item__name">
                    Report time
                  </div>
                  <div class="param-item__value report-time">
                    <v-text-field
                      v-model="form.hours"
                      dark
                      label="Hour"
                      hide-details
                      color="white"
                      outline
                      outlined
                      type="number"
                      @input.native="calculate($event, 'hours')"
                    />
                    <v-text-field
                      v-model="form.minutes"
                      dark
                      color="white"
                      label="Minutes"
                      hide-details
                      outline
                      outlined
                      type="number"
                      max="59"
                      @input.native="calculate($event, 'minutes')"
                    />
                  </div>
                </div>

                <div class="param-list__item param-item">
                  <div class="param-item__name">
                    Total price:
                  </div>
                  <div class="param-item__value">
                    {{ form.total }}$
                  </div>
                </div>

                <div class="param-list__item param-item cost">
                  <div class="param-item__name">
                    Your earnings:
                  </div>
                  <div class="param-item__value">
                    {{ form.commission || '-' }}$
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="d-flex justify-content-end">
                <v-btn
                  color="darken-1"
                  class="mr-2"
                  text
                  @click="$emit('close')"
                >
                  Cancel
                </v-btn>
                <v-btn
                  dark
                  color="green darken-1"
                  :loading="loading"
                  @click="submit"
                >
                  Approve
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import orderAPI from '@/api/orders.js';

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loading: false,
    form: {
      hours: null,
      minutes: null,
      commission: null,
      total: null,
    },
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },

      set(input) {
        this.$emit('input', input);
      },
    },

    timer() {
      const minutes = this.order.timer_minutes < 10
        ? `0${this.order.timer_minutes}`
        : this.order.timer_minutes;

      return `${this.order.timer_hours}H:${minutes}M`;
    },
  },

  watch: {
    model(val) {
      if (val) {
        this.init();
      }
    },
  },

  methods: {
    init() {
      const {
        timer_hours: hours,
        timer_minutes: mitutes,
        total_price: total,
        coach_commission: commission,
      } = this.order;

      this.form.hours = hours;
      this.form.minutes = mitutes;
      this.form.total = total;
      this.form.commission = commission;
    },

    submit() {
      this.loading = true;

      orderAPI.finish(this.order.inner_id, {
        hours: this.form.hours,
        minutes: this.form.minutes,
      })
        .then((response) => {
          if (response.data.success) {
            this.$emit('complete');
            this.$emit('close');
            this.$store.dispatch('initUser');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    calculate(e, field = null) {
      if (field === 'minutes' && e.target.value > 59) {
        this.form.minutes = 59;
      }

      if (field === 'hours' && e.target.value > 99) {
        this.form.hours = 99;
      }

      orderAPI.calculate(this.order.inner_id, {
        hours: this.form.hours,
        minutes: this.form.minutes,
      })
        .then((response) => {
          if (response.data.success) {
            this.form.total = response.data.data.total_price;
            this.form.commission = response.data.data.coach_price;
          }
        });
    },
  },
};
</script>

<style lang="scss">
.v-input--checkbox {
  label {
    margin-bottom: 0;
  }
}

.finish-order-wrapper {
  padding-bottom: 10px;
  font-size: 16px;

  p {
    font-size: 18px;
    padding: 0;
    margin: 0;
  }

  .v-input--selection-controls {
    margin-top: 0;
    margin-bottom: 0;
  }

  .v-input__slot {
    margin-bottom: 0;
  }

  .v-messages {
    display: none;
  }

  .param-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
  }

  .param-item {
    min-width: calc(50% - 20px);
    background: #464646;
    padding: 10px;
    margin: 10px;
    color: #fff;
    border-radius: 5px;

    a {
      color: #fff;
      text-decoration: underline;
    }

    &.cost {
      background: var(--color-secondary);
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
    }

    &__value {
      margin-top: 10px;
      font-size: 18px;
    }
  }
  .report-time {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    .v-text-field {
      max-width: 125px;
    }
  }
}
</style>
